export default "__VITE_ASSET__eca7fe66__"